<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">THE DOUBLE</span></p>
<p class="center"><span class="big1">HUMAN</span><br/><br/><br/><br/></p>
<p class="center001">                    J a m e s  O’ N e a l<br/><br/><br/><br/><br/><br/><br/></p>
<p class="center4"><img alt="" src="OEBPS/images/9781429949323_tp.png"/></p>
<p class="center">        <span class="small">A Tom Doherty Associates Book   New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429949323_epub_tp_r1.vue?abae7d8a